import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=ae20e794&"
import script from "./VideoGallery.vue?vue&type=script&lang=js&"
export * from "./VideoGallery.vue?vue&type=script&lang=js&"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=ae20e794&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports